import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading, signIn } = useAuth();

  // Auto-redirect to Cognito if not authenticated
  useEffect(() => {
    if (!loading && !isAuthenticated) {
      signIn();
    }
  }, [loading, isAuthenticated, signIn]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Show a brief message while redirecting
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Redirecting to sign in...</p>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
